
const duplicateProperties = (target, source, props) => {
    let styles = window.getComputedStyle(source);

    props.forEach(prop => {
        let propValue = styles[prop.name];
        if (typeof prop.handle === "function") {
            propValue = prop.handle(propValue);
        }
        if (prop.unit) {
            propValue = propValue + prop.unit;
        }
        target.style[prop.name] = propValue;
    })
}

class TextareaResizer {
    static init() {
        let els = Array.from(document.querySelectorAll('[data-auto-resize]'));
        els.forEach(el => {
            let offset = parseInt(el.dataset.offset) || 0;
            new TextareaResizer(el, offset);
        })
    }

    constructor(textarea, offset = 30) {
        this.field = textarea;

        this.clone = this.getClone();
        this.updateClone();

        this.offset = offset;

        this.initField();
    }

    getClone() {
        let clone = document.createElement('div');
        
        clone.style.position = "absolute";
        clone.style.visibility = "hidden";
        clone.style.color = "transparent";

        this.field.parentElement.insertBefore(clone, this.field);

        return clone;
    }

    updateClone() {
        duplicateProperties(this.clone, this.field, [
            { name: 'padding-top' },
            { name: 'padding-bottom' },
            { name: 'padding-left' },
            { name: 'padding-right' },
            { name: 'font-family' },
            { name: 'font-size' },
            { name: 'font-weight' },
            { name: 'font-style' },
            { name: 'line-height' },
        ])
        // let style = window.getComputedStyle(this.field);

        // this.clone.style.padding = style.padding;
        // this.clone.style.font = style.font;
        // this.clone.style.lineHeight = parseInt(style.lineHeight) + 2 + "px";

        let width = this.field.offsetWidth;
        this.clone.style.width = width + "px";

        let text = "";
        let value = this.field.value;
        value = value.replace(/[<>]/g, '_');
        value = value.split("\n");
        value.forEach(function(s) {
            text = text + '<div>' + s.replace(/\s\s/g, ' &nbsp;') + '&nbsp;</div>'+"\n";
        } );
        this.clone.innerHTML = text;
    }

    resize() {
        if (this.field.value == "") {
            this.field.style.height = "";
            return;
        }
        this.updateClone();
        let height = this.clone.offsetHeight + this.offset;
        this.field.style.height = height + "px";
    }

    initField() {
        this.field.style.resize = "none";
        this.field.style.overflow = "hidden";
        this.field.addEventListener('keyup', () => this.resize());
        this.field.addEventListener('textarea.resize', () => this.resize());

        this.resize();

        window.addEventListener("resize", () => {
            this.resize();
        });

        document.addEventListener("DOMContentLoaded", () => {
            this.resize();
        });
    }
}

export default TextareaResizer;